import type { SvgComponent } from '@/types/SvgComponent';

export const ArchiveIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M224 48H32A16 16 0 0 0 16 64V88a16 16 0 0 0 16 16v88a16 16 0 0 0 16 16H208a16 16 0 0 0 16-16V104a16 16 0 0 0 16-16V64A16 16 0 0 0 224 48ZM208 192H48V104H208ZM224 88H32V64H224ZM96 136a8 8 0 0 1 8-8h48a8 8 0 0 1 0 16H104A8 8 0 0 1 96 136Z"
        fill="currentColor"
      />
    </svg>
  );
};
